<template>
  <div class="c-engraving-keyboard">
    <div
      class="c-engraving-keyboard__wrapper l-flex l-flex--justify-start"
    >
      <EngravingKeyboardKey
        v-for="button in buttons"
        :key="button.name"
        :font="font"
        :type="type"
        v-bind="button"
        class="c-engraving-keyboard__key l-grid l-grid__item--align-center"
        @buttonClick="buttonClick"
      />
    </div>
  </div>
</template>
<script>
import EngravingKeyboardKey from "./EngravingKeyboardKey";
export default {
  components:{
    EngravingKeyboardKey,
  },
  props:{
    font:{
      type:String,
      default:''
    },
    buttons:{
      type:Array,
      default:()=>[]
    },
    type: {
      type:String,
      default: 'rectangle'
    }
  },
  methods:{
    buttonClick(symbol){
      this.$emit('buttonClick', symbol);
    }
  }
}
</script>
<style lang="scss" scoped>
.c-engraving-keyboard{
  &__wrapper{
    width:100%;
    margin:0 auto;
  }
  &__border-none{
    border: none !important;
  }
}
</style>